import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FieldError, errorClass } from '@/components/signup/FieldError';

// Labeled input with inline error; `hint` renders below when there is no error.
export default function SignupField({ id, label, error, testId, hint, ...inputProps }) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        name={id}
        aria-invalid={!!error}
        className={errorClass(error)}
        data-testid={testId}
        {...inputProps}
      />
      <FieldError id={`${testId.replace(/-input$/, '')}-error`} message={error} />
      {!error && hint}
    </div>
  );
}
